// Single source of truth for fleet-related React Query refetch cadences.
// The backend cron writes a fresh FleetSnapshot every 30s (and an extra
// event-driven snapshot the moment a mutation completes), so the UI polls at
// ~10s to surface changes within roughly one cron tick without hammering the
// read endpoints. Keeping these in one module ensures the workers overview,
// per-host history, and fleet-wide history all stay aligned.

/** Fleet status / workers-overview poll interval (ms). */
export const FLEET_STATUS_REFETCH_MS = 10_000;

/** Fleet history (per-host timeline + fleet-wide trends) poll interval (ms). */
export const FLEET_HISTORY_REFETCH_MS = 10_000;
